// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__3cQrW","wide":"Container_wide__2jdS6","halved":"Container_halved__2P4h_"};